// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N7q8","question":"styles_question__2JmUF","description":"styles_description__3H4r7"};